import { compact } from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'

import IconSecurityLocker from 'components/_special/IconSecurityLocker'
import List, { ListItem } from 'components/List'
import { H2 } from 'styles/components/typography'

import { SectionWrapperStyled, TextStyled } from './styles'

const BHowProtection = ({ data }) => {
  const listItems = compact(data.list)

  return (
    <SectionWrapperStyled className="bg--gray--op-06 d-md-flex align-items-md-center">
      <div className="row py-4 py-md-0">
        <div className="col-12 col-md-6">
          <IconSecurityLocker icon="bacteria" />
        </div>
        <div className="col-12 col-md-6 mt-4 mt-md-0">
          <H2 dangerouslySetInnerHTML={{ __html: data.title }} />
          <TextStyled dangerouslySetInnerHTML={{ __html: data.content }} />
          <List leftAlignment="text">
            {listItems.map((item, id) => (
              <ListItem
                className="with-inverted-links"
                key={`protection.${id}`}
                bulletColor="dark-blue"
              >
                {item}
              </ListItem>
            ))}
          </List>
        </div>
      </div>
    </SectionWrapperStyled>
  )
}

BHowProtection.propTypes = {
  data: PropTypes.object.isRequired,
}

BHowProtection.defaultProps = {}

export default BHowProtection
